import React, { useState, useEffect } from 'react'
import { cloneDeep } from 'lodash'

import { useSelector, useDispatch } from 'react-redux'

import { DateRangePicker, SingleDatePicker } from 'react-dates'

import { TimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'

import {
  Grid, Typography, Input,
  FormControlLabel, Divider, Button,
  Slider, Checkbox, TextField, Chip, Radio,
  List, ListItem, ListItemSecondaryAction, ListItemText, ListSubheader,
  withStyles, makeStyles, darken
} from '@material-ui/core'

import { Autocomplete } from '@material-ui/lab'

import moment from 'moment'
import { withRouter } from 'react-router-dom'

import { defaultFilter, statusTypes, statusFilterDetails } from '../../../../utils/variables'

import { searchViolationFields } from '../../../../redux/actions/violations'
import FilterSubscription from './FilterSubscription'
import FastFilterToggle from './FastFilterToggle'
import '../../styles/customClasses.css'

const useStyles = makeStyles((theme) => ({
  titleText: {
    // Blue
    color: '#007BFF'
  },
  sev120: {
    backgroundColor: '#5291fc'
  },
  sev2140: {
    backgroundColor: '#4e179a'
  },
  sev4160: {
    backgroundColor: '#f5d818'
  },
  sev6180: {
    backgroundColor: '#e7840f'
  },
  sev81100: {
    backgroundColor: '#d31111'
  },
  blueBackground: {
    backgroundColor: '#007BFF',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  greenBackground: {
    backgroundColor: '#97b557',
    '&:hover': {
      backgroundColor: '#0651C4'
    }
  },
  blueBtn: {
    color: '#5291fc',
    '&:hover': {
      color: darken('#5291fc', 0.15)
    }
  },
  greyColor: {
    color: '#0000008A'
  },
  lightGrey: {
    color: '#0000002b'
  },
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    position: 'relative',
    overflow: 'auto',
    maxHeight: 300
  },
  listSection: {
    backgroundColor: 'inherit'
  },
  ul: {
    backgroundColor: 'inherit',
    padding: 0
  },
  filterContainer: {
    padding: theme.spacing(0),
    // maxHeight: '70vh',
    margin: 'auto',
    width: '100%'
  },
  selectionContainer: {
    overflowY: 'scroll',
    maxHeight: '100%'
  },
  reportContainer: {
    maxHeight: '70vh',
    overflow: 'scroll'
  },
  fastFilterButtonOn: {
    color: '#0651C4',
    borderColor: '#0651C4'
  },
  fastFilterButtonOff: {
    color: '#B3B3B3',
    borderColor: '#B3B3B3'
  },
  fastFilterOffIcon: {
    color: '#B3B3B3',
    transition: '0.5s'
  },
  fastFilterOnIcon: {
    color: '#f5d818',
    transition: '0.5s'
  }
}))

const CustomSlider = withStyles({
  root: {
    height: '5px'
  },
  rail: {
    backgroundImage: 'linear-gradient(to right, rgba(82,145,252,1) 20%, rgba(78,23,154,1) 20% 40%, rgba(245,216,24,1) 40% 60%, rgba(231,132,15,1) 60% 80%, rgba(211,17,17,1) 80%)',
    height: '5px'
  },
  track: {
    height: '5px'
  },
  mark: {
    height: '5px',
    width: '5px',
    backgroundColor: '#fff'
  },
  markActive: {
    opacity: 1,
    backgroundColor: '#fff'
  }
})(Slider)

const StyledCheckBox = withStyles({
  root: {
    color: '#A4D164',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Checkbox color='default' {...props} />)

const StyledRadio = withStyles({
  root: {
    color: '#A4D164',
    '&$checked': {
      color: '#A4D164'
    }
  },
  checked: {}
})((props) => <Radio color='default' {...props} />)

const marks = [
  { value: 20, label: '' },
  { value: 40, label: '' },
  { value: 60, label: '' },
  { value: 80, label: '' },
  { value: 100, label: '' }
]

// reporting format options
const formatOptions = {
  CSV: 'CSV',
  PDF: 'PDF'
}

// api/db recognized frequency options for report
const subFrequencyAbbv = {
  HOURS: 'H',
  DAYS: 'D',
  WEEKS: 'W',
  MONTHS: 'M'
}

// labels used in filter 'receipt' report sentences based on the frequency type and interval
const subFrequencyLabels = {
  [subFrequencyAbbv.HOURS]: {
    steady: 'Hourly',
    intermittent: 'Hours'
  },
  [subFrequencyAbbv.DAYS]: {
    steady: 'Daily',
    intermittent: 'Days'
  },
  [subFrequencyAbbv.WEEKS]: {
    steady: 'Weekly',
    intermittent: 'Weeks'
  },
  [subFrequencyAbbv.MONTHS]: {
    steady: 'Monthly',
    intermittent: 'Months'
  }
}

// basic weekday array to use in report sentences
const weekdayArray = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

const FilterOptions = (props) => {
  const deepDefaultFilter = cloneDeep(defaultFilter)
  const {
    errors, newFormData = { ...deepDefaultFilter }, setFormData = () => { }, filterInfo = {}, isEditing,
    filterEditData, setFilterEditData,
    startDate, setStartDate, endDate, setEndDate, startTime, setStartTime, endTime, setEndTime,
    subOptions, setSubOptions, setSubEndSettings, subEndSettings, subErrCheck, subErrs,
    subEndObj, subDateErrCheck, resetDatesAndTime = () => { }
  } = props

  const {
    subEnabled = false, subFrequency, subFrequencyType, subStartTime, subStartDate, subSendEmailOn, subEndDate,
    subEndLimit, subFormat
  } = subOptions || {}

  const {
    dateSelectType = 'range',
    val = [], stationVal = [],
    // onlyFlagged = false,
    setVal = () => { }, setStationVal = () => { },
    // setFlagged = () => { },
    setDateSelectType = () => { }
  } = filterInfo

  const { error = false, timeError = false } = errors

  // const parsedProps = queryString.parse(props.location.search)
  // const ActiveView = parsedProps.view

  const classes = useStyles()
  const dispatch = useDispatch()

  const Categories = useSelector(state => state.words.categories)
  const filterOptions = useSelector(state => state.violations.filterSearch)
  const { permissions = [] } = useSelector(state => state.auth)

  const [focusedInput, setFocusedInput] = useState(null)
  const [singleFocusedInput, setSingleFocused] = useState(null)

  const [formattedStartTime, setFormattedStartTime] = useState(null)
  const [formattedEndTime, setFormattedEndTime] = useState(null)

  const [displayFormDates, setDisplayFormDates] = useState({ start: null, end: null })

  const [stationInput, setStationInput] = useState('')
  const [userInput, setUserInput] = useState('')

  const [searchInProgress, setSearchInProgress] = useState(false)
  const [fieldSuggestions, setFieldSuggestions] = useState({ username: [], workstationName: [] })

  const [isEditingName, setIsEditingName] = useState([])

  // Allows DateRangePicker to Select Values outside its range
  const outsideRange = () => false

  useEffect(() => {
    if (typeof filterOptions === 'object' && Array.isArray(filterOptions.username) && Array.isArray(filterOptions.workstationName)) {
      if (Boolean(filterOptions.username.length) && !filterOptions.workstationName.length) {
        const temp = filterOptions.username.map((option) => option.key)
        setFieldSuggestions({ username: temp, workstationName: [] })
      } else if (Boolean(filterOptions.workstationName.length) && !filterOptions.username.length) {
        const temp = filterOptions.workstationName.map((option) => option.key)
        setFieldSuggestions({ username: [], workstationName: temp })
      } else {
        setFieldSuggestions({ username: [], workstationName: [] })
      }
    }

    return () => { setFieldSuggestions({ username: [], workstationName: [] }) }
  }, [filterOptions, dispatch])

  useEffect(() => {
    if (newFormData.startTime > 0) {
      setFormattedStartTime(moment(newFormData.startTime).format('hh:mm a'))
    } else { setFormattedEndTime(null) }

    if (newFormData.endTime > 0) {
      setFormattedEndTime(moment(newFormData.endTime).format('hh:mm a'))
    } else { setFormattedEndTime(null) }

    if (newFormData.startDate > 0 || (newFormData.startDate > 0 && newFormData.endDate > 0)) {
      setDisplayFormDates({ start: moment(newFormData.startDate).format('MM/DD/YYYY'), end: moment(newFormData.endDate).format('MM/DD/YYYY') })
    } else { setDisplayFormDates({ start: null, end: null }) }
  }, [newFormData])

  // Format user friendly sentence(s) to use in filter 'receipt' to display their chosen shedule for reports.
  const formatDeliveryOptions = () => {
    // only format the sentence if the user has selected to schedule a filter.
    if (subEnabled) {
      // default begining
      let delivery = 'Report Scheduled'

      // add the chosen format of the report (e.g 'CSV' or 'PDF')
      if (subFormat && Object.values(formatOptions).includes(subFormat)) {
        delivery = `${subFormat} ${delivery} `
      }

      // if they have chosen a frequency
      if (subFrequency !== null) {
        // parse the string
        const parsedSubFrequency = parseInt(subFrequency)
        // boolean to check if the frequency is greater than one
        const intermittentFrequency = Boolean(parsedSubFrequency > 1)

        // if the user has selected regular intervals for the delivery use the mapping objects to diplay the correct wording
        if (intermittentFrequency) {
          // eg: 'CSV Report Scheduled every 2 days'
          delivery = `${delivery} Every ${subFrequency} ${subFrequencyLabels[subFrequencyType]?.intermittent}`
        } else {
          // otherwise use the 'steady' label, eg: Daily CSV Report Scheduled
          delivery = `${subFrequencyLabels[subFrequencyType]?.steady} ${delivery}`
        }

        // Specifically when choosing 'week' type, the user has a choice of which day in the week to receive the report.
        if (subFrequencyType === subFrequencyAbbv.WEEKS && subSendEmailOn !== null) {
          // add this selected day to the sentence
          delivery += `on ${weekdayArray[subSendEmailOn]}s`
        }

        // add their chosen start time
        if (subStartTime) { delivery += ` at ${subStartTime.format('h:mma')}` }

        // if a number of occurrances has been selected, add that as well
        if (subEndLimit) {
          delivery += ` for ${subEndLimit} Occurrences`
        }

        // end the first sentence
        delivery += '.'
      }

      // add another sentence for when they want the report to start sending
      if (subStartDate) { delivery += ` Beginning on ${subStartDate.format('LL')}.` }

      // add another sentence if they have chosen an end time
      if (subEndDate) { delivery += ` Ending on ${subEndDate.format('LL')}.` }

      // return the full sentence or set of sentences
      return delivery
    }

    // default sentence if no delivery option is scheduled
    return 'No delivery report schedule selected.'
  }

  const handleUserInputChange = (e) => {
    e.preventDefault()
    setUserInput(e.target.value)
    // search suggestions from api as needed
    if (e.target.value && e.target.value.length > 3) {
      if (!searchInProgress) {
        setSearchInProgress(true)

        dispatch(searchViolationFields(
          { ...deepDefaultFilter, usernames: newFormData.usernames },
          e.target.value,
          'username',
          {
            onSuccess: () => { setSearchInProgress(false) }, onFailure: () => { setSearchInProgress(false) }
          }
        ))
      }
    } else {
      setFieldSuggestions({ username: [], workstationName: fieldSuggestions.workstationName })
      if (searchInProgress) { setSearchInProgress(false) }
    }
  }

  const handleWorkstationInputChange = async (e) => {
    e.preventDefault()
    setStationInput(e.target.value)
    // search suggestions from api as needed
    if (e.target.value && e.target.value.length > 3) {
      if (!searchInProgress) {
        setSearchInProgress(true)

        dispatch(searchViolationFields(
          { ...deepDefaultFilter, workstations: newFormData.workstations },
          e.target.value,
          'workstationName',
          {
            onSuccess: () => { setSearchInProgress(false) }, onFailure: () => { setSearchInProgress(false) }
          }
        ))
      }
    } else {
      setFieldSuggestions({ username: fieldSuggestions.username, workstationName: [] })
      if (searchInProgress) { setSearchInProgress(false) }
    }
  }

  const checkSource = () => {
    if (newFormData.source === 0) {
      return 'Keyboard'
    } else if (newFormData.source === 1) {
      return 'Application'
    } else {
      return 'All'
    }
  }

  const handleSliderChange = (event, newValue) => {
    setFormData({
      ...newFormData,
      severityMin: newValue[0],
      severityMax: newValue[1]
    })
  }

  // The below is used for the additional terms input that is currently not being used but may be put back in later
  // const handleAdditionalInput = (e) => {
  //   const selected = e
  //   setFormData({ ...newFormData, additionalTerms: selected || [] })
  // }

  // const handleAdditionalSuggestions = (e) => {
  //   const text = e
  //   if (text.length > 3) {
  //   }
  // }

  const handleDateChange = (startDate, endDate) => {
    if (dateSelectType === 'range') {
      if (startDate !== null && endDate !== null) {
        // These are for displaying correctly in the receipt
        const formatStartDate = startDate.format('LL')
        const formatEndDate = endDate.format('LL')
        setDisplayFormDates({ start: formatStartDate, end: formatEndDate })
      } else {
        setDisplayFormDates({ start: null, end: null })
      }
      setStartDate(startDate)
      setEndDate(endDate)
      const start = startDate
      const end = endDate
      setFormData({ ...newFormData, startDate: start, endDate: end })
    } else if (dateSelectType === 'single') {
      if (startDate !== null) {
        const formatStartDate = startDate.format('LL')
        setDisplayFormDates({ start: formatStartDate, end: formatStartDate })
      } else {
        setDisplayFormDates({ start: null, end: null })
      }
      setStartDate(startDate)
      setEndDate(null)
      const start = startDate
      const end = endDate
      setFormData({ ...newFormData, startDate: start, endDate: end })
    }
  }

  const handleStartTimeChange = (startTime) => {
    if (startTime !== null) {
      const formatTime = startTime.format('h:mm:A')
      setFormattedStartTime(formatTime)
    } else if (startTime === null) {
      setFormattedStartTime('')
    }
    setStartTime(startTime)
    setFormData({ ...newFormData, startTime })
  }

  const handleEndTimeChange = (endTime) => {
    if (endTime !== null) {
      const formatTime = endTime.format('h:mm:A')
      setFormattedEndTime(formatTime)
    } else if (startTime === null) {
      setFormattedStartTime('')
    }
    setEndTime(endTime)
    setFormData({ ...newFormData, endTime })
  }

  const handleFocusedInput = (focus) => {
    setFocusedInput(focus)
  }

  const handleSingleFocus = (focus) => {
    setSingleFocused(focus.focused)
  }

  /**
   *
   * @param {Array} user array with string value denoting user to be added
   */
  const handleAddUser = (e) => {
    const userValue = e.target.textContent
    if (!userValue) { return false }

    const index = newFormData.usernames.indexOf(userValue)
    const usernames = [...newFormData.usernames]

    const usersToAdd = [...newFormData.usersToAdd]
    const addUsers = usersToAdd.indexOf(userValue)
    const usersToDelete = [...newFormData.usersToDelete]
    const deleteUsers = usersToDelete.indexOf(userValue)
    // updated to handle add/delete arrays for editing saved filters
    if (index === -1) {
      usernames.push(userValue)

      if (addUsers === -1) {
        usersToAdd.push(userValue)
      }
      if (deleteUsers > -1) {
        usersToDelete.splice(deleteUsers, 1)
      }
    } else {
      usernames.splice(index, 1)

      if (addUsers > -1) {
        usersToAdd.splice(addUsers, 1)
      }
      if (deleteUsers === -1) {
        usersToDelete.push(userValue)
      }
    }

    setUserInput('')
    setVal(usernames)
    setFormData({
      ...newFormData,
      usernames,
      usersToAdd,
      usersToDelete
    })
  }
  /**
   *
   * @param {String} option string value denoting user to be removed
   */
  const handleDeleteUser = (option) => {
    setVal(val.filter(entry => entry !== option))
    const users = [...newFormData.usernames]

    // new handling for multiple arrays
    const newuser = users.filter(entry => entry !== option)
    const deleteUsers = [...newFormData.usersToDelete]
    const addUsers = [...newFormData.usersToAdd]
    // add station to stations to delete if not exists
    const deleteUsr = deleteUsers.indexOf(option)
    // remove the station from the add array if exists
    const addUsr = addUsers.indexOf(option)
    if (deleteUsr === -1) {
      deleteUsers.push(option)
    }
    if (addUsr > -1) {
      addUsers.splice(addUsr, 1)
    }
    setFormData({
      ...newFormData,
      usernames: newuser,
      usersToAdd: addUsers,
      usersToDelete: deleteUsers
    })
  }

  /**
   *
   * @param {Array} station an array with typically a string values denoting the station names to be added
   */
  const handleAddStation = (e) => {
    const stationValue = e.target.textContent
    if (!stationValue) { return false }

    const index = newFormData.workstations.indexOf(stationValue)
    const workstations = [...newFormData.workstations]

    const workstationsToAdd = [...newFormData.workstationsToAdd]
    const addStats = workstationsToAdd.indexOf(stationValue)
    const workstationsToDelete = [...newFormData.workstationsToDelete]
    const deleteStats = workstationsToDelete.indexOf(stationValue)
    // updated to handle add/delete arrays for editing saved filters
    if (index === -1) {
      workstations.push(stationValue)

      if (addStats === -1) {
        workstationsToAdd.push(stationValue)
      }
      if (deleteStats > -1) {
        workstationsToDelete.splice(deleteStats, 1)
      }
    } else {
      workstations.splice(index, 1)

      if (addStats > -1) {
        workstationsToAdd.splice(addStats, 1)
      }
      if (deleteStats === -1) {
        workstationsToDelete.push(stationValue)
      }
    }

    setStationInput('')
    setStationVal(workstations)
    setFormData({
      ...newFormData,
      workstations,
      workstationsToAdd,
      workstationsToDelete
    })
  }
  /**
   *
   * @param {String} station a string value denoting the station to be removed.
   */
  const handleStationDelete = (station) => {
    setStationVal(stationVal.filter(entry => entry !== station))
    const stations = [...newFormData.workstations]

    // new handling for multiple arrays
    const newStation = stations.filter(entry => entry !== station)
    const deleteStations = [...newFormData.workstationsToDelete]
    const addStations = [...newFormData.workstationsToAdd]
    // add station to stations to delete if not exists
    const deleteWrk = deleteStations.indexOf(station)
    // remove the station from the add array if exists
    const addWrk = addStations.indexOf(station)
    if (deleteWrk === -1) {
      deleteStations.push(station)
    }
    if (addWrk > -1) {
      addStations.splice(addWrk, 1)
    }
    setFormData({
      ...newFormData,
      workstationsToAdd: addStations,
      workstationsToDelete: deleteStations,
      workstations: newStation
    })
  }

  const handleFlagged = () => {
    // setFlagged((prev) => !prev)
    const newArray = [...newFormData.captureAreas]
    const index = newArray.indexOf('Flagged')
    if (index === -1) {
      newArray.push('Flagged')
    } else {
      newArray.splice(index, 1)
    }

    const flaggedIndex = newFormData.captureAreas.indexOf('Flagged')
    const captureAreas = [...newFormData.captureAreas]
    const statusesToAdd = [...newFormData.statusesToAdd]
    const addStats = statusesToAdd.indexOf('Flagged')
    const statusesToDelete = [...newFormData.statusesToDelete]
    const deleteStats = statusesToDelete.indexOf('Flagged')
    // updated to handle add/delete arrays for editing saved filters
    if (flaggedIndex === -1) {
      captureAreas.push('Flagged')

      if (addStats === -1) {
        statusesToAdd.push('Flagged')
      }
      if (deleteStats > -1) {
        statusesToDelete.splice(deleteStats, 1)
      }
    } else {
      captureAreas.splice(flaggedIndex, 1)

      if (addStats > -1) {
        statusesToAdd.splice(addStats, 1)
      }
      if (deleteStats === -1) {
        statusesToDelete.push('Flagged')
      }
    }

    setFormData({ ...newFormData, captureAreas: newArray, statusesToAdd, statusesToDelete })
  }

  const handleDateType = (type) => {
    if (newFormData.startDate !== '' || newFormData.endDate !== '') {
      setFormData({ ...newFormData, startDate: '', endDate: '' })
    }
    setDateSelectType(type)
  }

  const resetSeverity = () => {
    setFormData({
      ...newFormData,
      severityMin: 1,
      severityMax: 100
    })
  }

  const setCapture = (e) => {
    const code = e.target.id
    const index = newFormData.captureAreas.indexOf(code)
    const captureAreas = [...newFormData.captureAreas]
    const statusesToAdd = [...newFormData.statusesToAdd]
    const addStats = statusesToAdd.indexOf(code)
    const statusesToDelete = [...newFormData.statusesToDelete]
    const deleteStats = statusesToDelete.indexOf(code)

    // updated to handle add/delete arrays for editing saved filters
    if (index === -1) {
      captureAreas.push(code)

      if (addStats === -1) {
        statusesToAdd.push(code)
      }
      if (deleteStats > -1) {
        statusesToDelete.splice(deleteStats, 1)
      }
    } else {
      captureAreas.splice(index, 1)

      // Removed if block that was previously dispatching the setFilter action when a selected status was unchecked

      if (addStats > -1) {
        statusesToAdd.splice(addStats, 1)
      }
      if (deleteStats === -1) {
        statusesToDelete.push(code)
      }
    }

    setFormData({
      ...newFormData,
      captureAreas,
      statusesToAdd,
      statusesToDelete
    })
  }

  const setSource = (value) => {
    const id = value === 'keyboard' ? 0 : value === 'application' ? 1 : value
    setFormData({ ...newFormData, source: id })
  }

  const setSeverity = (value1, value2) => {
    setFormData({
      ...newFormData,
      severityMax: value1,
      severityMin: value2
    })
  }

  const setCategory = (e, categoryID) => {
    // const { categoriesToAdd, categoriesToDelete, categories: formCategories } = { ...newFormData }

    // const formIx = formCategories.indexOf(categoryID)

    // if (formIx !== -1) {
    //   formCategories.push()
    // }

    // if (formIx !== -1 && categories.)

    const id = e.target.id
    const index = newFormData.categories.indexOf(id)
    const categories = [...newFormData.categories]

    const addCats = [...newFormData.categoriesToAdd]
    const addCat = addCats && addCats.indexOf(categoryID)
    const deleteCats = [...newFormData.categoriesToDelete]
    const removeCat = deleteCats && deleteCats.indexOf(categoryID)

    if (index === -1) {
      // we're adding
      categories.push(id)
      if (addCat === -1) {
        addCats.push(categoryID)
      }
      if (removeCat > -1) {
        deleteCats.splice(removeCat, 1)
      }
      setFormData({
        ...newFormData,
        categories,
        categoriesToAdd: addCats,
        categoriesToDelete: deleteCats
      })
    } else {
      // we're deleting
      categories.splice(index, 1)
      if (removeCat === -1) {
        deleteCats.push(categoryID)
      }
      // remove from the add array
      if (addCat > -1) {
        addCats.splice(addCat, 1)
      }
      setFormData({
        ...newFormData,
        categories,
        categoriesToAdd: addCats,
        categoriesToDelete: deleteCats
      })
    }

    const categoryIDIndex = filterEditData.categoriesToAdd.indexOf(categoryID)
    const tempCategoriesToAdd = [...filterEditData.categoriesToAdd]
    if (index === -1) { tempCategoriesToAdd.push(categoryID) } else { tempCategoriesToAdd.splice(categoryIDIndex, 1) }
    setFilterEditData({ ...filterEditData, categoriesToAdd: tempCategoriesToAdd })
  }

  const formatDisplayTime = () => {
    if (dateSelectType === 'single' && displayFormDates.start !== null) {
      return `${displayFormDates.start}`
    } else if (dateSelectType === 'range' && displayFormDates.start !== null && displayFormDates.end !== null) {
      return `${displayFormDates.start} - ${displayFormDates.end}`
    } else {
      return 'All'
    }
  }

  useEffect(() => {
    return () => {
      setUserInput('')
    }
  }, [])

  return (
    <Grid container direction='row' spacing={2}>
      <Grid item container id='report-detail-area' direction='row' xs={3}>
        <Grid container item direction='column' xs={11}>
          <Grid item>
            <Typography
              gutterBottom
              className='font-weight-bold'
              variant='h6'
            >
              Filter Details
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant='overline'
              color='primary'
              classes={{ colorPrimary: classes.titleText }}
              display='block'
            >
              Severity:
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant='caption'
              id='report-severity-range'
            >
              {newFormData.severityMin !== undefined && newFormData.severityMax ? `${newFormData.severityMin === 0 ? 1 : newFormData.severityMin} - ${newFormData.severityMax}` : 'All'}
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant='overline'
              color='primary'
              classes={{ colorPrimary: classes.titleText }}
              display='block'
            >
              Categories:
            </Typography>
          </Grid>

          {
            newFormData.categories.length !== 0
              ? newFormData.categories.map((item) => {
                return (
                  <Grid item key={`new-item-${item}`}>
                    <Typography
                      variant='caption'
                      style={{ textTransform: 'capitalize' }}
                    >
                      {item.toLowerCase()}
                    </Typography>
                  </Grid>
                )
              })
              : (
                <Grid item>
                  <Typography variant='caption'>All</Typography>
                </Grid>)
          }
          <Grid item>
            <Typography
              variant='overline'
              color='primary'
              classes={{ colorPrimary: classes.titleText }}
              display='block'
            >
              Statuses:
            </Typography>
          </Grid>

          {
            newFormData.captureAreas.length !== 0
              ? newFormData.captureAreas.map((item) => {
                const detailObj = statusFilterDetails.find(x => x.statusValue === item)
                const label = item !== statusTypes.FLAGGED ? detailObj ? detailObj?.statusLabel : '--' : item
                return (
                  <Grid item key={`new-item-${item}`}>
                    <Typography
                      variant='caption'
                    >
                      {label}
                    </Typography>
                  </Grid>
                )
              })
              : (
                <Grid item>
                  <Typography variant='caption'>All</Typography>
                </Grid>)
          }

          <Grid item>
            <Typography
              variant='overline'
              color='primary'
              classes={{ colorPrimary: classes.titleText }}
              display='block'
            >
              Sources:
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant='caption'
            >
              {checkSource()}
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant='overline'
              color='primary'
              classes={{ colorPrimary: classes.titleText }}
              display='block'
            >
              Users:
            </Typography>
          </Grid>

          {
            val.length !== 0
              ? val.map((item) => {
                return (
                  <Grid item key={`new-item-${item}`}>
                    <Typography
                      variant='caption'
                    >
                      {item}
                    </Typography>
                  </Grid>
                )
              })
              : (
                <Grid item><Typography variant='caption'>All</Typography></Grid>)
          }

          <Grid item>
            <Typography
              variant='overline'
              color='primary'
              classes={{ colorPrimary: classes.titleText }}
              display='block'
            >
              Stations:
            </Typography>
          </Grid>

          {
            newFormData.workstations && newFormData.workstations.length !== 0
              ? newFormData.workstations.map((item) => {
                return (
                  <Grid item key={`new-station-${item}`}>
                    <Typography
                      variant='caption'
                    >
                      {item}
                    </Typography>
                  </Grid>
                )
              })
              : (
                <Grid item><Typography variant='caption'>All</Typography></Grid>)
          }

          <Grid item>
            <Typography
              variant='overline'
              color='primary'
              classes={{ colorPrimary: classes.titleText }}
              display='block'
            >
              Time Range:
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant='caption'
            >
              {formattedStartTime !== null && formattedEndTime !== null ? formattedStartTime !== '' && formattedEndTime !== '' ? `${formattedStartTime} - ${formattedEndTime}` : 'All' : 'All'}
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant='overline'
              color='primary'
              classes={{ colorPrimary: classes.titleText }}
              display='block'
            >
              Date Range:
            </Typography>
          </Grid>

          <Grid item>
            <Typography
              variant='caption'
            >
              {formatDisplayTime()}
              {/* {displayFormDates.start !== undefined && displayFormDates.end !== undefined ? displayFormDates.start !== null && displayFormDates.end !== null ? `${displayFormDates.start} - ${displayFormDates.end}` : 'All' : 'All'} */}
            </Typography>
          </Grid>

          {/* When editing a saved filter, display any scheduled report information */}
          {isEditing &&
            <>
              <Grid item>
                <Typography
                  variant='overline'
                  color='primary'
                  classes={{ colorPrimary: classes.titleText }}
                  display='block'
                >
                  Delivery Options:
                </Typography>
              </Grid>

              {/* ***** Here lies Cat's favorite easter egg. It remained in prod, undetected, for over two years. May it rest in peace ***** */}
              {/* <Grid item>
                <Typography
                  variant='caption'
                >
                  Coming Soon to a theater near you.
                </Typography>
              </Grid> */}
              {/* ****** */}

              {/* Formated sentence(s) explaining the user scheduled report selection */}
              <Grid item>
                <Typography
                  variant='caption'
                >
                  {formatDeliveryOptions()}
                </Typography>
              </Grid>
            </>}
        </Grid>
        <Divider orientation='vertical' flexItem style={{ marginTop: '-1em' }} />
      </Grid>

      <Grid item container direction='column' xs={9} id='report-selection-area'>
        {isEditing &&
          <Grid item container direction='column' style={{ marginBottom: '2em' }}>
            <Grid item container>
              <Typography className='font-weight-bold' variant='h6'>Filter Properties:</Typography>
            </Grid>
            <Divider style={{ width: '100%', marginLeft: '-2em', paddingRight: '3.5em' }} />
            <Grid item container direction='row' alignItems='center' style={{ marginTop: '1em' }}>
              <Grid item container direction='column' xs={8}>
                <Typography gutterBottom variant='body2' style={{ fontWeight: 600, color: '#6A6A6A' }}>Name:</Typography>
                {isEditingName
                  ? (
                    <Input
                      value={newFormData.filterName}
                      style={{ color: '#98B556', fontSize: '28px', fontWeight: '700' }}
                      onChange={(e) => setFormData({ ...newFormData, filterName: e.target.value })}
                    />)
                  : (
                    <Typography style={{ color: '#98B556', fontSize: '28px', fontWeight: '700' }}>{newFormData.filterName}</Typography>)}
              </Grid>
              <Grid item container justify='center' xs={4}>
                <Button
                  variant='outlined'
                  size='small'
                  onClick={(e) => { e.preventDefault(); setIsEditingName(true) }}
                  style={{ textTransform: 'none' }}
                >
                  Rename
                </Button>
              </Grid>
            </Grid>
            <Grid item container direction='column' style={{ marginTop: '1.5em' }}>
              <Grid item>
                <FilterSubscription
                  subOptions={subOptions}
                  subEndSettings={subEndSettings}
                  setSubEndSettings={setSubEndSettings}
                  setSubOptions={setSubOptions}
                  filterName={newFormData.filterName}
                  isEditing={isEditing}
                  subErrCheck={subErrCheck}
                  subErrs={subErrs}
                  subEndObj={subEndObj}
                  subDateErrCheck={subDateErrCheck}
                  resetDatesAndTime={resetDatesAndTime}
                />
              </Grid>
              <Grid item>
                <FastFilterToggle
                  newFormData={newFormData}
                  setFormData={setFormData}
                />
              </Grid>
            </Grid>
          </Grid>}

        <Grid container item direction='column'>
          {isEditing &&
            <Grid item container>
              <Typography className='font-weight-bold' variant='h6'>Filter Selections:</Typography>
              <Divider style={{ width: '100%', marginLeft: '-2em', paddingRight: '3.5em' }} />
            </Grid>}
          {/* START SEVERITY */}
          <Grid container item direction='row' style={{ marginTop: isEditing ? '1em' : 0 }}>
            <Typography variant='h6' className='font-weight-bold' color='primary' classes={{ colorPrimary: classes.greyColor }}>Severity</Typography>
          </Grid>

          <Grid container item direction='row' justify='center'>
            <Grid container justify='center' item xs={12}>
              <Typography variant='subtitle1'>{`${newFormData.severityMin === 0 ? 1 : newFormData.severityMin} - ${newFormData.severityMax}`}</Typography>
            </Grid>
          </Grid>

          <Grid container item style={{ marginBottom: '30px' }} direction='row' justify='center'>
            <Grid item xs={11}>
              <CustomSlider
                className='mt-5'
                value={[newFormData.severityMin, newFormData.severityMax]}
                onChange={handleSliderChange}
                aria-labelledby='range-slider'
                min={1}
                max={100}
                marks={marks}
                valueLabelDisplay='on'
              />
            </Grid>
          </Grid>

          <Grid container item direction='row' justify='center' name='severityGroup' id='severityGroup' className='mb-3'>
            <Grid item>
              <Button id='0' size='large' variant='contained' style={{ marginRight: '8px', padding: '8px 8px' }} color='primary' classes={{ containedPrimary: classes.sev120 }} onClick={() => setSeverity(20, 1)}>1-20</Button>
            </Grid>
            <Grid item>
              <Button id='1' size='large' variant='contained' style={{ marginRight: '8px', padding: '8px 8px' }} color='primary' classes={{ containedPrimary: classes.sev2140 }} onClick={() => setSeverity(40, 21)}>21-40</Button>
            </Grid>
            <Grid item>
              <Button id='2' size='large' variant='contained' style={{ marginRight: '8px', padding: '8px 8px' }} color='primary' classes={{ containedPrimary: classes.sev4160 }} onClick={() => setSeverity(60, 41)}>41-60</Button>
            </Grid>
            <Grid item>
              <Button id='3' size='large' variant='contained' style={{ marginRight: '8px', padding: '8px 8px' }} color='primary' classes={{ containedPrimary: classes.sev6180 }} onClick={() => setSeverity(80, 61)}>61-80</Button>
            </Grid>
            <Grid item>
              <Button id='4' size='large' variant='contained' style={{ marginRight: '8px', padding: '8px 8px' }} color='primary' classes={{ containedPrimary: classes.sev81100 }} onClick={() => setSeverity(100, 81)}>81-100</Button>
            </Grid>
            <Grid item>
              <Button size='large' variant='contained' style={{ padding: '8px 8px' }} onClick={resetSeverity} id='5'>All</Button>
            </Grid>
          </Grid>
          {/* END SEVERITY */}
        </Grid>

        <Grid container item direction='row'>
          <List subheader={<li />} className={classes.root}>
            <li className={classes.listSection}>
              <ul className={classes.ul}>
                <ListSubheader className='pl-0'>
                  <Typography variant='h6' className='font-weight-bold'>Categories</Typography>
                </ListSubheader>
                {Categories.map((category) => {
                  return (
                    <ListItem key={`category-${category.categoryID}`}>
                      <ListItemText id={`check-${category.categoryID}`} style={{ textTransform: 'capitalize' }}>{category.categoryName.toLowerCase()}</ListItemText>
                      <ListItemSecondaryAction>
                        <StyledCheckBox
                          edge='end'
                          checked={newFormData.categories.includes(`${category.categoryName}`)}
                          onChange={(e) => { e.preventDefault(); setCategory(e, category.categoryID) }}
                          id={`${category.categoryName}`}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                  )
                })}
              </ul>
            </li>
          </List>
        </Grid>

        <Grid container item direction='column' className='mt-3'>
          <Grid container item direction='row'>
            <Grid item xs>
              <Typography variant='h6' color='primary' classes={{ colorPrimary: classes.greyColor }} className='mb-3 mt-4 font-weight-bold'>Statuses</Typography>
            </Grid>
          </Grid>

          <Grid container item direction='row' spacing={1}>
            <Grid item xs>
              <FormControlLabel
                control={
                  <StyledCheckBox
                    // checked={onlyFlagged}
                    checked={newFormData.captureAreas.includes('Flagged')}
                    onChange={handleFlagged}
                    id='flagged'
                    className='p-0'
                  />
                }
                label={<span style={{ fontSize: '.9rem' }}>Flagged</span>}
                labelPlacement='top'
                className='font-weight-bold ml-0'
              />
            </Grid>

            {statusFilterDetails?.map(statusObj => {
              const { statusValue, statusLabel, statusPermission } = statusObj
              const optionIsDisabled = Boolean(permissions?.length && !permissions.includes(statusPermission))
              return (
                <Grid item xs key={`cature-status-${statusValue}`}>
                  <FormControlLabel
                    disabled={optionIsDisabled}
                    control={
                      <StyledCheckBox
                        checked={newFormData.captureAreas.includes(statusValue)}
                        onChange={setCapture}
                        id={statusValue}
                        className='p-0'
                      />
                    }
                    label={<span style={{ fontSize: '.9rem', whiteSpace: 'nowrap' }}>{statusLabel}</span>}
                    labelPlacement='top'
                    className='font-weight-bold'
                  />
                </Grid>
              )
            })}
          </Grid>
        </Grid>

        <Grid container item direction='column'>
          <Grid container item direction='row'>
            <Grid item>
              <Typography variant='h6' color='primary' classes={{ colorPrimary: classes.greyColor }} className='font-weight-bold'>Sources</Typography>
            </Grid>
          </Grid>

          <Grid container item direction='row' spacing={3} className='mx-auto w-100' name='sourceGroup' id='sourceGroup' style={{ marginBottom: '10px' }}>
            <Grid item>
              <Button variant='contained' id='keyboard' color='primary' classes={{ containedPrimary: newFormData.source === 0 ? classes.blueBackground : classes.greenBackground }} onClick={() => setSource('keyboard')}>Keyboard</Button>
            </Grid>

            <Grid item>
              <Button variant='contained' color='primary' classes={{ containedPrimary: newFormData.source === 1 ? classes.blueBackground : classes.greenBackground }} id='application' onClick={() => setSource('application')}>Application</Button>
            </Grid>

            <Grid item>
              <Button variant='contained' color='primary' classes={{ containedPrimary: newFormData.source === 'all' || newFormData.source === '' ? classes.blueBackground : classes.greenBackground }} id='all' onClick={() => setSource('all')}>All</Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid container item direction='column'>
          <Grid container item spacing={2} direction='row'>
            <Grid item xs={6} className='mb-4'>
              <Typography variant='h6' gutterBottom className='font-weight-bold' color='primary' classes={{ colorPrimary: classes.greyColor }}>Users</Typography>
              <Autocomplete
                multiple
                freeSolo
                value={newFormData.usernames}
                filterOptions={(options) => options.sort((a, b) => typeof a === 'string' && a.localeCompare(b))}
                limitTags={1}
                loading={searchInProgress}
                open={userInput.length > 3}
                onClose={() => setFieldSuggestions({ username: [], workstationName: [] })}
                onChange={(e, newValue) => { e.preventDefault(); handleAddUser(e, newValue) }}
                getOptionSelected={(option, value) => option === value}
                size='small'
                id='user-tags'
                options={fieldSuggestions.username}
                renderTags={(value, getTagProps) =>
                  newFormData.usernames.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      variant='outlined'
                      key={`new-user-${option}`}
                      label={option}
                      onDelete={() => { handleDeleteUser(option) }}
                    />
                  ))}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant='standard'
                    label='Select Users'
                    onChange={e => handleUserInputChange(e)}
                  />
                )}
              />
            </Grid>

            <Grid item xs={6} className='mb-4'>
              <Typography gutterBottom variant='h6' className='font-weight-bold' color='primary' classes={{ colorPrimary: classes.greyColor }}>Station Name</Typography>
              <Autocomplete
                multiple
                freeSolo
                loading={searchInProgress}
                value={newFormData.workstations}
                limitTags={1}
                filterOptions={(options) => options.sort((a, b) => typeof a === 'string' && a.localeCompare(b))}
                open={stationInput.length > 3}
                onClose={() => setFieldSuggestions({ username: [], workstationName: [] })}
                onChange={(e, newValue) => { e.preventDefault(); handleAddStation(e, newValue) }}
                getOptionSelected={(option, value) => option === value}
                size='small'
                id='station-tags'
                options={fieldSuggestions.workstationName}
                renderTags={(value, getTagProps) =>
                  newFormData.workstations.map((option, index) => (
                    <Chip
                      {...getTagProps({ index })}
                      variant='outlined'
                      key={`station-${option}`}
                      label={option}
                      onDelete={() => handleStationDelete(option)}
                    />
                  ))}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant='standard'
                    label='Select WorkStations'
                    onChange={(e) => { handleWorkstationInputChange(e) }}
                  />
                )}
              />
            </Grid>
          </Grid>

          <Grid container item spacing={2} direction='row'>
            <Grid item xs={6}>
              <Typography variant='h6' className='font-weight-bold' color='primary' classes={{ colorPrimary: subOptions.subEnabled ? classes.lightGrey : classes.greyColor }}>Date Range</Typography>
              <Grid item container direction='row'>
                <FormControlLabel
                  value='single'
                  control={<StyledRadio size='small' checked={dateSelectType === 'single'} />}
                  onClick={(e) => !subOptions.subEnabled ? handleDateType(e.target.value) : false}
                  label='Single'
                  labelPlacement='end'
                  style={{ margin: 0 }}
                  disabled={subOptions.subEnabled}
                />
                <FormControlLabel
                  value='range'
                  control={<StyledRadio size='small' checked={dateSelectType === 'range'} />}
                  onClick={(e) => !subOptions.subEnabled ? handleDateType(e.target.value) : false}
                  label='Range'
                  labelPlacement='end'
                  style={{ margin: 0 }}
                  disabled={subOptions.subEnabled}
                />
              </Grid>
              {error &&
                <Typography variant='overline' color='error' style={{ textTransform: 'none' }}>You Must Select Both Start And End Dates</Typography>}
              {dateSelectType === 'range' &&
                <DateRangePicker
                  small
                  showClearDates
                  startDate={startDate}
                  startDateId='your_unique_start_date_id'
                  endDate={endDate}
                  endDateId='your_unique_end_date_id'
                  onDatesChange={({ startDate, endDate }) => handleDateChange(startDate, endDate)}
                  focusedInput={focusedInput}
                  onFocusChange={focusedInput => handleFocusedInput(focusedInput)}
                  startDatePlaceholderText='Start Date'
                  endDatePlaceholderText='End Date'
                  isOutsideRange={outsideRange}
                  orientation='vertical'
                  openDirection='up'
                  disabled={subOptions.subEnabled}
                />}
              {dateSelectType === 'single' &&
                <SingleDatePicker
                  small
                  showClearDate
                  date={startDate}
                  onDateChange={date => handleDateChange(date, null)}
                  focused={singleFocusedInput}
                  onFocusChange={(focused) => handleSingleFocus(focused)}
                  id='SingleDatePicker'
                  orientation='vertical'
                  openDirection='up'
                  isOutsideRange={outsideRange}
                  disabled={subOptions.subEnabled}
                />}
            </Grid>
            <Grid item xs={6}>
              <Typography variant='h6' className='font-weight-bold' color='primary' classes={{ colorPrimary: subOptions.subEnabled ? classes.lightGrey : classes.greyColor }}>Time Range</Typography>
              {timeError &&
                <Typography variant='overline' color='error' style={{ textTransform: 'none' }}>You Must Select Both Start And End Times</Typography>}
              <Grid container direction='row'>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <Grid item xs={5}>
                    <TimePicker
                      label='Start Time'
                      clearable
                      value={startTime}
                      disabled={startDate == null || subOptions.subEnabled}
                      onChange={(e) => handleStartTimeChange(e)}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
                <Grid item xs={2} container justify='center'>
                  <Typography variant='subtitle1' color='primary' classes={{ colorPrimary: classes.greyColor }}>to</Typography>
                </Grid>
                <MuiPickersUtilsProvider utils={MomentUtils}>
                  <Grid item xs={5}>
                    <TimePicker
                      label='End Time'
                      clearable
                      value={startTime !== null ? endTime : null}
                      disabled={startDate == null || startTime == null || subOptions.subEnabled}
                      onChange={(e) => handleEndTimeChange(e)}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              </Grid>
            </Grid>
          </Grid>
          {/* Removing the below Input until it is added into the ES search query in the api */}
          {/* <Grid container direction='column'>
            <Grid item xs={12}>
              <Typography variant='h6' className='font-weight-bold' color='primary' classes={{ colorPrimary: classes.greyColor }}>Additional Terms</Typography>
              <FormControl fullWidth variant='outlined' size='small'>
                <OutlinedInput
                  id='additionalInput'
                  onKeyUp={handleAdditionalSuggestions}
                  onChange={handleAdditionalInput}
                  options={additionalOptions}
                  selected={newFormData.additionalTerms}
                  minLength={minLength}
                />
              </FormControl>
            </Grid>
          </Grid> */}
        </Grid>

      </Grid>
    </Grid>
  )
}

export default withRouter(FilterOptions)
